/*
 * @Author: cc
 * @Date: 2020-01-06 22:13:00
 * @LastEditTime : 2020-01-07 11:52:39
 * @LastEditors  : cc
 * @FilePath: \xjmediacloud\app\editingCenter\app\service\appParams.js
 * @Description: app 渠道处理公共参数服务
 */
'use strict';
angular.module('appParamsModule', []).factory('appParamsService', [
    '$q',
    '$state',
    'trsspliceString',
    'appConst',
    function($q, $state, trsspliceString, appConst) {
        return {
            /**
             * [dealParams description] 处理操作参数
             * @param   {[object]}  basicParams   [basicParams description]基本参数
             * @param   {[Array]}   items         [items description]稿件集合
             * @return  {[promise]}               [return description]
             */
            dealParams: function(basicParams, items) {
                var defer = $q.defer();
                var params = {
                    serviceid: appConst.params.serviceid,
                    MetaDataIds: items ? trsspliceString.spliceString(items, 'METADATAID', ',') : $state.params.appmetadataid, // 如果传入的是集合就表示在列表页，否则就是查看页
                    ChnlDocIds: items ? trsspliceString.spliceString(items, 'CHNLDOCID', ',') : $state.params.appchnldocid,
                    ChannelId: $state.params.appchannelid,
                };
                defer.resolve(angular.extend(basicParams, params));
                return defer.promise;
            },
        };
    },
]);
